import React, { useState, useEffect, useContext, useMemo } from "react";
import informesContext from "../../context/informesContext/informesContext";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import controlContext from "../../context/control/controlContext";
import { ALERTSProcedimientosProgramados } from "../../utils/states";
import normalizeText from "../../utils/normalizeText";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import activoContext from "../../context/activoContex/activoContex";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaProcsProgramados = ({setGridToShow}) =>{

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango, 
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        filtrar
    } = cContext;

    const uContext = useContext(usuariosContext);
    const {userListView, saveColumnsPreferences} = uContext

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const iContext = useContext(informesContext);
    const {generarInformeExcel} = iContext;

    const acContext = useContext(activoContext);
    const {procsProgramadosList,getMantenimientosProgramados,calcularMantenimientos} = acContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasProcsProgramados ?? [], [usuario])

    const [columns, setColumns] = useState([
        {width: 225, property: 'codProc', title: 'Cod. Procedimiento', visible: true },
        {width: 375, property: 'nameProcedimiento', title: 'Procedimiento', visible: true },
        {width: 225, property: 'codActivo', title: 'Cod. Activo', visible: true },
        {width: 350, property: 'nameActivo', title: 'Activo', visible: true },
        {width: 125, property: 'alertaString', title: 'Tipo Alerta', visible: true },
        {width: 75, property: 'tareas', title: 'Tareas', visible: true },
        {width: 150, property: 'uniMedString', title: 'Unidad Medida', visible: true },
        {width: 100, property: 'stateString', title: 'Estado', visible: true },
        {width: 100, property: 'CodForOT', title: 'Código', visible: true },
        {width: 125, property: 'NroForOT', title: 'Número OT', visible: true },
    ]);

    const [procsFiltered,setProcsFiltered] = useState(undefined);
    const [filter,setFilter] = useState('');
    const [showFilters,setShowFilter] = useState(false);
    const [showSelectColumns,setShowSelectColumns] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({todos: 1, vencidos: 0, porVencer:0});
    const [selct,setSelec] = useState([])

    const handlerIniciarlizarFiltros = async () => {
        const state = ALERTSProcedimientosProgramados;
        await iniciarFiltros(state, usuario);
    }

    const handleGenerarInforme = async() =>{
        let dataToExcel = []; //Arreglo que contendra tanto el Header del excel como las Filas Hijas de Informacion.
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title); //Arreglo que contiene el nombre de las columnas o header.
        dataToExcel.push(columnsTitle); //Se pushea la primer fila del excel.

        //Por cada OT filtrada se crea un array nuevo, a este se le pushearan las propiedades que hayan sido especificadas en la visualizacion del informe en el frontend.
        
        for(const o of procsFiltered){
            let otModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                (Array.isArray(o[col.property])) ? otModelado.push(o[col.property].length) : otModelado.push(o[col.property]);
            }
            if(otModelado.length > 0) dataToExcel.push(otModelado); //Si algun campo coincidio lo pushea a dataToExcel para ser impresa en el .xlsx.
        }
        await generarInformeExcel(dataToExcel, 'ProcedimientosProgramados'); //Viaja hacia la funcion del contexto para ser generado el xlsx.
    }

    const handleChangeColumnsVisible = (e, c, i) =>{
        setColumns((prevCols) => prevCols.map((c,index) => index == i ? {...c, visible: e.target.checked} : c))
    }

    const handlerClickFilter = (itm) => {
        setShowFilter(false)
    }

    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    useEffect(() => {
        getMantenimientosProgramados();
        handlerIniciarlizarFiltros();
    }, []);

    useEffect(()=>{
    if(procsProgramadosList != undefined){
        if(filter != ''){
            const nFilter = normalizeText(filter);
            let procs = procsProgramadosList.filter(p => (normalizeText(p.codProc).includes(nFilter) || normalizeText(p.nameProcedimiento).includes(nFilter) || normalizeText(p.nameActivo).includes(nFilter) || normalizeText(p.codActivo).includes(nFilter)));
            setProcsFiltered(procs);
        }else setProcsFiltered(procsProgramadosList);
    }
    },[filter]);

    useEffect(()=>{
        if(procsProgramadosList != undefined && procsProgramadosList != null){
            let procsFiltradosToSet = filtrar(procsProgramadosList,filtrosEstado,filtrosRango,'ProcedimientosProgramados');
            setProcsFiltered(procsFiltradosToSet);
        };
    },[procsProgramadosList,filtrosEstado,filtrosRango]);

    useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0){
            setColumns(prevColumns => prevColumns.map(c => ({...c, visible: columnsPreferences.includes(c.property)})))
        }
    },[columnsPreferences])


    return <div className="grillaInformeDiv">
    <div className="utilitiesDiv">
        <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        <SearchInput filter={filter} buscar={setFilter}/>
        <FilterScreen verFiltro={setShowFilter}/>
        <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
        <button disabled={procsFiltered == undefined || procsFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
    </div>
    {(procsFiltered == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (procsFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay ordenes de trabajo cargadas</h3> : <Table array={procsFiltered} columns={columns} setColumns={setColumns}/>}
    {
        showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"ProcsProgramados"}/>
    }
    {showFilters &&
            <div className="addFilterContainer">
                <AddFilter
                    usuarios={userListView} 
                    item={selectedFilter} 
                    cerrar={handlerClickFilter} 
                    filtro={{filtrosRango, filtrosEstado}} 
                    aplicarFiltros={apFiltros} 
                    workspace={activeWorkSpace} 
                    selct={selct}
                    setSelec={setSelec}
                    componentePadre='ProcedimientosProgramados'
                />
            </div>
        }
</div>

}

export default GrillaProcsProgramados;